import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { ProjectType } from '../objects/ProjectType';
import { environment } from '../environments/environment';

@Injectable({ providedIn: 'root' })
export class ProjectTypeService {
  private apiUrl = environment.apiUrl + 'ProjectTypes';

  constructor(private http: HttpClient) {}

  getProjectTypes(): Observable<ProjectType[]> {
    return this.http.get<any[]>(this.apiUrl).pipe(
      map(items => items.map(t => ({
        id: t.id ?? t.Id,
        type: t.type ?? t.Type ?? ''
      })))
    );
  }

  create(type: string): Observable<ProjectType> {
    return this.http.post<ProjectType>(this.apiUrl, { type });
  }

  update(id: number, type: string): Observable<any> {
    return this.http.put(`${this.apiUrl}/${id}`, { id, type });
  }

  delete(id: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${id}`);
  }
}
